import { InvoiceDeliveryTypeEnum } from "src/_api";

export const InvoiceDeliveryTypeTranslations = {
  [InvoiceDeliveryTypeEnum.Mail]: 'Brev',
  [InvoiceDeliveryTypeEnum.Email]: 'E-post'
};
